<button matButton type="button" class="btn-info" #tooltip="matTooltip"
[attr.aria-label]="tooltipText()"
[matTooltip]="tooltipText()"
[matTooltipPosition]="tooltipPosition()">
    <mat-icon class="material-symbols-outlined" fontIcon="info" />
</button>
